import { Navigate, useParams } from 'react-router-dom'
import { useAuthStore } from '@stores/authStore'

/**
 * Role-adaptive redirect for shared property links (notifications, tasks, ...).
 * Routes investors to the investor view and all other roles (admin, sales,
 * signer, tenant_admin, ...) to the sales view.
 */
export function PropertyRedirect() {
  const { id } = useParams<{ id: string }>()
  const { user } = useAuthStore()
  const target =
    user?.role === 'investor'
      ? `/investor/properties/${id}`
      : `/sales/properties/${id}`
  return <Navigate to={target} replace />
}

export default PropertyRedirect
